import { ref, watch } from "vue";

/**
 * Mirrors the host's `search` prop into a local ref and relays the container's
 * own search bar input upward as `update-search`. Used by every navigation
 * container so the search wiring is declared once.
 *
 * The emit lives in the input handler, not a watcher on the ref: every
 * `update-search` is user typing by construction, so prop-driven syncs are
 * mirrored silently and hosts can treat the event as input without guessing
 * its origin.
 */
export function useContainerSearch(props, emit) {
  const search = ref(props.search);

  watch(
    () => props.search,
    (value) => {
      search.value = value;
    },
  );

  // Call from the panel's `update-search` handler (its search box input).
  function applySearchInput(value) {
    search.value = value;
    emit("update-search", value);
  }

  return { search, applySearchInput };
}
